// extracted by mini-css-extract-plugin
export default {"root":"farewell_message_root__IXd-C","text":"farewell_message_text__NNO1D"};